import { useEffect, useState, Fragment } from "react";

import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import DownloadForOfflineIcon from "@mui/icons-material/DownloadForOffline";
import Tooltip from "@mui/material/Tooltip";

import { useSelector } from "react-redux";

import { CSVLink } from "react-csv";

import { getAllMetadataFromIds } from "../../../Logic/getAllMetadataFromIds";
import { getBasicMetadataFromIds } from "../../../Logic/getBasicMetadataFromIds";
import { getLookupsForItemsInCart } from "../../../Logic/getLookupsForItemsInCart";
import { getNamesOfParentTablesForItemsInCart } from "../../../Logic/getNamesOfParentTablesForItemsInCart";

import config from "../../../config.json";

const { baseURLforScripts, baseURLforData, tableNamesWithScripts } = config;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  pt: 2,
  px: 4,
  pb: 3,
};

function CartExportModal() {
  const idsOfItemsInCart = useSelector((state) => state.idsOfItemsInCart);

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  const [allMetadata, setAllMetadata] = useState([]);
  const [basicMetadata, setBasicMetadata] = useState([]);
  const [lookups, setLookups] = useState([]);
  const [namesOfParentTables, setNamesOfParentTables] = useState([]);

  useEffect(() => {
    const arrayOfIds = idsOfItemsInCart;

    const allMetadata = getAllMetadataFromIds(arrayOfIds);
    setAllMetadata(allMetadata);

    const basicMetadata = getBasicMetadataFromIds(arrayOfIds);
    setBasicMetadata(basicMetadata);

    const lookups = getLookupsForItemsInCart(arrayOfIds);
    setLookups(lookups);

    const namesOfParentTables =
      getNamesOfParentTablesForItemsInCart(arrayOfIds);
    setNamesOfParentTables(namesOfParentTables);
  }, [idsOfItemsInCart]);

  const renderButtonToDownloadLookups = () => {
    return (
      <CSVLink data={lookups} filename={"lookups.csv"}>
        <Tooltip
          title="Lookups include: 
                    Name of Parent Table, Variable DOI, Variable Name,
                    Permissible Value, and Permissible Value Meaning"
        >
          <Button size="small">Download Lookups</Button>
        </Tooltip>
      </CSVLink>
    );
  };

  const renderWhenNoLookups = () => {
    return (
      <Button size="small" disabled>
        No Lookups for variables in Cart
      </Button>
    );
  };

  const renderTableRows = () => {
    console.log({ namesOfParentTables });
    return namesOfParentTables.map((tableName, i) => {
      const key = tableName;

      // console.log({ tableName });
      // console.log({ tableNamesWithScripts });
      // console.log(tableNamesWithScripts.includes(tableName));

      if (!tableNamesWithScripts.includes(tableName)) {
        return null;
      }

      const baseURL = baseURLforScripts;

      const nameOfDataFile = `${tableName}.csv`;
      const linkToDataFile = `${baseURLforData}/${nameOfDataFile}`;

      const nameOfRScript = `${tableName}.r`;
      const linkToRScript = `${baseURL}/import-data-r/${nameOfRScript}`;

      const nameOfSasScript = `${tableName}.sas`;
      const linkToSasScript = `${baseURL}/import-data-sas/${nameOfSasScript}`;

      const nameOfStataScript = `${tableName}.do`;
      const linkToStataScript = `${baseURL}/import-data-stata/${nameOfStataScript}`;

      if (baseURLforData) {
        return (
          <TableRow key={key}>
            <TableCell>
              {/*
  
             
               {`${tableName}`}
        */}
              <a href={`${linkToDataFile}`} download={`${nameOfDataFile}`}>
                {`${tableName}.csv`}
              </a>
            </TableCell>
            <TableCell>
              {" "}
              <a href={`${linkToRScript}`} download={`${nameOfRScript}`}>
                {nameOfRScript}
              </a>
            </TableCell>
            <TableCell>
              {" "}
              <a href={`${linkToSasScript}`} download={`${nameOfSasScript}`}>
                {nameOfSasScript}
              </a>
            </TableCell>
            <TableCell>
              {" "}
              <a
                href={`${linkToStataScript}`}
                download={`${nameOfStataScript}`}
              >
                {nameOfStataScript}
              </a>
            </TableCell>
          </TableRow>
        );
      } else {
        return (
          <TableRow key={key}>
            <TableCell>{`${tableName}`}</TableCell>
            <TableCell>
              {" "}
              <a href={`${linkToRScript}`} download={`${nameOfRScript}`}>
                {nameOfRScript}
              </a>
            </TableCell>
            <TableCell>
              {" "}
              <a href={`${linkToSasScript}`} download={`${nameOfSasScript}`}>
                {nameOfSasScript}
              </a>
            </TableCell>
            <TableCell>
              {" "}
              <a
                href={`${linkToStataScript}`}
                download={`${nameOfStataScript}`}
              >
                {nameOfStataScript}
              </a>
            </TableCell>
          </TableRow>
        );
      }
    });
  };

  const renderWhenDataExists = () => {
    return (
      <Grid item xs={12}>
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Data and Scripts
            </Typography>

            <Stack>
              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <b>Data</b>. Download the parent CSV files for the variables in
                your cart.{" "}
                <i>
                  Permission to access the BLSA Data Science SharePoint Online
                  site is requred.
                </i>
              </Typography>

              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <b>Scripts</b>. Download scripts that will load your CSV files
                into R, SAS, or Stata and then label the variables and values.
              </Typography>

              <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                <Table size="small" stickyHeader aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Parent Table</TableCell>
                      <TableCell>R Script</TableCell>
                      <TableCell>SAS Script</TableCell>
                      <TableCell>Stata Script</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{renderTableRows()}</TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const renderWhenNoDataExists = () => {
    return (
      <Grid item xs={12}>
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Scripts
            </Typography>

            <Stack>
              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <b>Scripts</b>. Download scripts that will load CSV files into
                R, SAS, or Stata and then label the variables and values.
              </Typography>

              <TableContainer component={Paper} sx={{ maxHeight: 300 }}>
                <Table size="small" stickyHeader aria-label="a dense table">
                  <TableHead>
                    <TableRow>
                      <TableCell>Parent Table</TableCell>
                      <TableCell>R Script</TableCell>
                      <TableCell>SAS Script</TableCell>
                      <TableCell>Stata Script</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>{renderTableRows()}</TableBody>
                </Table>
              </TableContainer>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const renderWhenNoneOfSelectedVariablesExistInData = () => {
    return (
      <Grid item xs={12}>
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            <Typography variant="h5" color="text.secondary" gutterBottom>
              Scripts
            </Typography>

            <Stack>
              <Typography variant="body2" sx={{ mb: 1.5 }}>
                <b>Scripts</b>. We have not generated scripts to load in the
                tables for the variables you have selected.
              </Typography>
            </Stack>
          </CardContent>
        </Card>
      </Grid>
    );
  };

  const renderScriptSection = () => {
    if (
      tableNamesWithScripts.filter((d) => namesOfParentTables.includes(d))
        .length === 0
    ) {
      return renderWhenNoneOfSelectedVariablesExistInData();
    }
    return baseURLforData ? renderWhenDataExists() : renderWhenNoDataExists();
  };

  return (
    <Fragment>
      <Tooltip title="Download files related to cart contents">
        <IconButton onClick={handleOpen}>
          <DownloadForOfflineIcon></DownloadForOfflineIcon>
        </IconButton>
      </Tooltip>
      <Modal
        hideBackdrop
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box sx={{ ...style }}>
          <h2 id="child-modal-title">
            Download files related to cart contents
          </h2>

          <Grid container spacing={1}>
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h5" color="text.secondary" gutterBottom>
                    Metadata
                  </Typography>

                  <Typography
                    sx={{ mb: 1.5 }}
                    color="text.secondary"
                  ></Typography>
                  <Typography variant="body2">
                    Download a CSV file of metadata for the variables in your
                    cart.
                  </Typography>
                </CardContent>
                <CardActions>
                  <CSVLink data={basicMetadata} filename={"basic-metadata.csv"}>
                    <Tooltip title="Basic metadata incldues Directory of Parent Table, Name of Parent Table, Variable DOI, Variable Name, and Variable Label">
                      <Button size="small">Basic</Button>
                    </Tooltip>
                  </CSVLink>
                  <CSVLink
                    data={allMetadata}
                    filename={"detailed-metadata.csv"}
                  >
                    <Tooltip title="Detailed metadata incldues the Basic metadata plus everything else in the MetaEncyclopedia">
                      <Button size="small">Detailed</Button>
                    </Tooltip>
                  </CSVLink>
                </CardActions>
              </Card>
            </Grid>
            <Grid item xs={6}>
              <Card>
                <CardContent>
                  <Typography variant="h5" color="text.secondary" gutterBottom>
                    Lookups
                  </Typography>

                  <Typography
                    sx={{ mb: 1.5 }}
                    color="text.secondary"
                  ></Typography>
                  <Typography variant="body2">
                    Download a CSV file of lookups for variables in your cart.
                  </Typography>
                </CardContent>
                <CardActions>
                  {lookups.length > 0
                    ? renderButtonToDownloadLookups()
                    : renderWhenNoLookups()}
                </CardActions>
              </Card>
            </Grid>

            {baseURLforScripts ? renderScriptSection() : null}
          </Grid>

          <Button onClick={handleClose}>Return to Cart</Button>
        </Box>
      </Modal>
    </Fragment>
  );
}

export default CartExportModal;
